module.exports = __webpack_public_path__ + "static/media/icon_insight_round.2bff14d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icon_insight_round.svg
// module id = 355
// module chunks = 0